<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Delete Session Report'"
    :submit-button-text="'DELETE'"
    :reset-modal="resetModal"
    :submit-modal="deleteSessionReport"
    :modal-error="deleteError"
    :modal-error-text="deleteErrorText"
    ><b-row v-if="report">
      <b-col>
        <p class="tsny_text">
          This action will delete the session report from
          {{ report.date }} . Please be absolutely certain you want to do this
          -- this action cannot be undone.
        </p>
      </b-col>
    </b-row></tsny-modal
  >
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";
export default {
  name: "DeleteSessionReportModal",
  components: { TsnyModal },
  props: {
    id: {
      type: String,
      default: null
    },
    report: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      modalId: "deleteSessionReportModal",
      deleteError: null,
      deleteErrorText: "An error occurred deleting the session report"
    };
  },
  methods: {
    deleteSessionReport: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.deleteError = false;

      return CourseRelationshipRestService.deleteSessionReport(
        $comp.id,
        $comp.report._id
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.deleteError = true;
          console.log(err);
        });
    },
    resetModal: function() {
      this.deleteError = null;
    }
  }
};
</script>

<style scoped></style>
